import { Box, Flex } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContactInfo, FacebookLink, FooterLinks } from './FooterComponents'
import { IContactInfo, IFooterLink } from './types'

export const HomeFooter: React.FC = () => {
  const { t } = useTranslation()
  const contactInfo: IContactInfo = {
    companyName: 'Fetch / Enexus Oy',
    address: 'Juurakkotie 6, 01510 Vantaa',
    phone: '020 719 9744',
  }

  const links: IFooterLink[] = [
    { link: 'https://fetch.fi', label: t('footer.aboutUs'), target: '_blank' },
    { link: '/terms-of-delivery', label: t('footer.tos') },
    { link: '/privacy-policy', label: t('footer.privacyPolicy') },
  ]

  return (
    <Flex
      as='div'
      boxShadow='xl'
      mt='2rem'
      px='36px'
      py='48px'
      flexDirection='row'
      justifyContent='space-between'
      pb='100px'
    >
      <Box flex='1' mb={2} px={2}>
        <ContactInfo {...contactInfo} />
      </Box>
      <Box flex='1' mb={2} px={2}>
        <FooterLinks links={links} />
      </Box>
      <Box flex='0.5' px={2}>
        {' '}
        {/* Reducing flex value for Facebook link box */}
        <FacebookLink link='https://www.facebook.com/profile.php?id=100063655294262' />
      </Box>
    </Flex>
  )
}
